import { Stack } from '@mui/joy';
import { UploadSimple } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button, SlidingPanel, SlidingPanelContent } from 'core/components';
import { ButtonFileUpload } from 'core/elements';
import { FileExtension, NotificationPosition } from 'core/enums';
import { Color } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onUploadImage: (file: File) => void;
  onUploadDatasheet: (file: File) => void;
  onChooseVideo: () => void;
  disabled?: boolean;
}

const IMAGE_ACCEPT = [
  FileExtension.JPEG,
  FileExtension.JPG,
  FileExtension.PNG,
  FileExtension.GIF,
  FileExtension.SVG,
];
const DATASHEET_ACCEPT = [FileExtension.PDF];

export const UploadFile = ({
  isOpen,
  onClose,
  onUploadImage,
  onUploadDatasheet,
  onChooseVideo,
  disabled = false,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <SlidingPanel isOpen={isOpen} onClosePanel={onClose} title={t('titleUploadFile')}>
      <SlidingPanelContent notificationPosition={NotificationPosition.FORM} fullWidth={false}>
        <Stack sx={{ gap: 1.5, paddingTop: 1 }}>
          <ButtonFileUpload
            color={Color.PRIMARY}
            text={
              <>
                <UploadSimple weight="fill" /> {t('labelImage')}
              </>
            }
            acceptTypes={IMAGE_ACCEPT}
            onUpload={onUploadImage}
            disabled={disabled}
          />
          <ButtonFileUpload
            color={Color.PRIMARY}
            text={
              <>
                <UploadSimple weight="fill" /> {t('labelDatasheet')}
              </>
            }
            acceptTypes={DATASHEET_ACCEPT}
            onUpload={onUploadDatasheet}
            disabled={disabled}
          />
          <Button
            color={Color.PRIMARY}
            text={
              <>
                <UploadSimple weight="fill" /> {t('labelVideo')}
              </>
            }
            onClick={onChooseVideo}
            disabled={disabled}
          />
        </Stack>
      </SlidingPanelContent>
    </SlidingPanel>
  );
};
